<script lang="ts">
	// The design system's Eyebrow (design/components/core/Eyebrow.jsx): the
	// small mono label over or beside a thing. Coloured text goes through the
	// accent aliases, never the fill pigments, as the design says.

	interface Props {
		text: string;
		tone?: 'muted' | 'speed' | 'ledger' | 'on-ink' | 'on-ledger';
		testId?: string;
	}

	let { text, tone = 'muted', testId }: Props = $props();
</script>

<p class="eyebrow {tone}" data-testid={testId}>{text}</p>

<style>
	.eyebrow {
		margin: 0;
		font-family: var(--font-mono);
		font-size: var(--text-micro);
		letter-spacing: var(--tracking-label);
		font-weight: var(--weight-semibold);
	}

	.muted {
		font-size: var(--text-eyebrow);
		letter-spacing: var(--tracking-eyebrow);
		font-weight: var(--weight-regular);
		color: var(--text-muted);
	}

	.speed {
		color: var(--accent-speed);
	}

	.ledger {
		color: var(--accent-visibility);
	}

	.on-ink {
		color: var(--speed-on-ink);
	}

	.on-ledger {
		color: var(--ledger-mid);
	}
</style>
